export const VIEW_ALLOW = [
  "normal",
  "all",
  "today",
  "privilege",
  "overdue",
  "material"
];
